/**
 * Path-picker for the three CM Wizard paths. Used as the header on each of
 * the three CM Wizard pages so users can switch between Manual, Document
 * Upload, and Spreadsheet Import without going back to a menu.
 */

import { NavLink } from "react-router-dom";

const paths = [
  { to: "/cm-wizard", label: "Enter manually" },
  { to: "/cm-wizard/document", label: "Upload supplier invoice" },
  { to: "/cm-wizard/spreadsheet", label: "Import spreadsheet" },
];

export default function CmWizardPathNav(): React.ReactElement {
  return (
    <div style={styles.bar}>
      {paths.map((p) => (
        <NavLink
          key={p.to}
          to={p.to}
          end
          style={({ isActive }) => ({
            ...styles.link,
            ...(isActive ? styles.linkActive : {}),
          })}
        >
          {p.label}
        </NavLink>
      ))}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    display: "flex",
    gap: 4,
    marginBottom: 24,
    borderBottom: "1px solid #1E2230",
  },
  link: {
    padding: "10px 14px",
    fontSize: 13,
    color: "#7C829A",
    textDecoration: "none",
    borderBottom: "2px solid transparent",
    marginBottom: -1,
  },
  linkActive: {
    color: "#E6E6E6",
    borderBottom: "2px solid #4ADE80",
  },
};
